module.exports = __webpack_public_path__ + "img/meetup1.3381740b.jpeg";